export default  {
  generateSessionCode: () => {
    const now = new Date();

    // Opciones para formatear la fecha y hora en la zona horaria de Buenos Aires
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false, // Asegura el formato de 24 horas
      timeZone: 'America/Argentina/Buenos_Aires'
    };

    // Crear un formateador de fechas para obtener las partes de la fecha en la zona horaria deseada.
    // Usamos 'en-US' para el locale base ya que nos da un orden predecible de las partes
    // y evitamos separadores específicos de otros locales que no sean '-' o ':'.
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(now);

    // Reconstruir la cadena en el formato 'YYYY-MM-DD HH:mm:ss'
    let year, month, day, hour, minute, second;
    for (const part of parts) {
      switch (part.type) {
        case 'year': year = part.value; break;
        case 'month': month = part.value; break;
        case 'day': day = part.value; break;
        case 'hour': hour = part.value; break;
        case 'minute': minute = part.value; break;
        case 'second': second = part.value; break;
      }
    }

    return `${year}.${month}.${day}__${hour}.${minute}.${second}`;
  },
  getCommonLogData: (location) => {
    return {
      path: location.pathname,
      userAgent: navigator.userAgent,
      browserLanguage: navigator.language,
      platform: navigator.platform,
    };
  },
  getArgentinaTimeStamp: () => {
    // Obtener la fecha y hora actual
    const now = new Date();

    // Opciones para formatear la fecha y hora en la zona horaria de Buenos Aires
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false, // Asegura el formato de 24 horas
      timeZone: 'America/Argentina/Buenos_Aires'
    };

    // Crear un formateador de fechas para obtener las partes de la fecha en la zona horaria deseada.
    // Usamos 'en-US' para el locale base ya que nos da un orden predecible de las partes
    // y evitamos separadores específicos de otros locales que no sean '-' o ':'.
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(now);

    // Reconstruir la cadena en el formato 'YYYY-MM-DD HH:mm:ss'
    let year, month, day, hour, minute, second;
    for (const part of parts) {
      switch (part.type) {
        case 'year': year = part.value; break;
        case 'month': month = part.value; break;
        case 'day': day = part.value; break;
        case 'hour': hour = part.value; break;
        case 'minute': minute = part.value; break;
        case 'second': second = part.value; break;
      }
    }

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
}